import { Box } from '@edreamsodigeo/prisma-design-system';
import { FormInput } from '@/components/FormField';
import { CountrySelector } from '@/components/CountrySelector';
import React from 'react';
import { useTranslation, createFeature } from '@edreamsodigeo/frontend-core';
import { FormRow, StyledBoxDesktop, StyledBoxMobile } from './formUtils';
import { useLogin } from '@/providers/login/LoginProvider';
import { PRIME_FIRST_PHASE_2_DESKTOP } from '@/versionedComponents';
import { withFlowComponent } from '@/HOC/withFlowComponent';

const ConfirmEmailFieldWrapper = (props) => (
  <Box mt="big">
    <FormInput {...props} />
  </Box>
);

const VersionedConfirmEmailFieldDesktop = createFeature({
  name: PRIME_FIRST_PHASE_2_DESKTOP,
  variations: [null, ConfirmEmailFieldWrapper, ConfirmEmailFieldWrapper],
  version: 1,
});

const ConfirmEmailField = withFlowComponent(
  ConfirmEmailFieldWrapper,
  VersionedConfirmEmailFieldDesktop
);

export const ContactDetailsForm = ({
  data,
  onBlur,
  showErrors,
  emailDisabled,
  emailValidation,
  formDisabled,
  formFields,
}) => {
  const { t } = useTranslation();
  const { isLogged } = useLogin();

  return (
    <>
      <Box mt="big">
        <FormInput
          id={formFields.EMAIL.id}
          label={t('pricefreeze.form.passenger.email.account')}
          value={data?.[formFields.EMAIL.id] || ''}
          type="email"
          onBlur={onBlur(formFields.EMAIL.id)}
          validate={emailValidation || formFields.EMAIL.validation}
          showErrors={showErrors}
          disabled={emailDisabled}
        />

        {!isLogged && (
          <ConfirmEmailField
            id={formFields.EMAIL_CONFIRM?.id}
            label={t('pricefreeze.form.passenger.email.confirm')}
            value={data[formFields.EMAIL_CONFIRM?.id]}
            type="email"
            onBlur={onBlur(formFields.EMAIL_CONFIRM?.id)}
            validate={(value) =>
              formFields.EMAIL_CONFIRM?.validation(value) &&
              value === data[formFields.EMAIL.id]
            }
            showErrors={showErrors}
            disabled={false}
          />
        )}
      </Box>

      <Box mt="big">
        <FormRow>
          <StyledBoxDesktop mr="2x_small" flex={1}>
            <FormInput
              id={formFields.NAME.id}
              label={t('pricefreeze.form.passenger.name')}
              value={data?.[formFields.NAME.id] || ''}
              type="text"
              onBlur={onBlur(formFields.NAME.id)}
              validate={formFields.NAME.validation}
              showErrors={showErrors}
              disabled={formDisabled}
            />
          </StyledBoxDesktop>
          <StyledBoxDesktop ml="2x_small" flex={1}>
            <StyledBoxMobile mt="big">
              <FormInput
                id={formFields.SURNAME.id}
                label={t('pricefreeze.form.passenger.surname')}
                value={data?.[formFields.SURNAME.id] || ''}
                type="text"
                onBlur={onBlur(formFields.SURNAME.id)}
                validate={formFields.SURNAME.validation}
                showErrors={showErrors}
                disabled={formDisabled}
              />
            </StyledBoxMobile>
          </StyledBoxDesktop>
        </FormRow>
      </Box>

      <Box mt="big" mb="base">
        <FormRow>
          <StyledBoxDesktop mr="2x_small" flex={1}>
            <CountrySelector
              id={formFields.COUNTRY_CODE.id}
              label={t('pricefreeze.form.passenger.phone.country')}
              value={data?.[formFields.COUNTRY_CODE.id] || ''}
              onBlur={onBlur(formFields.COUNTRY_CODE.id)}
              validate={formFields.COUNTRY_CODE.validation}
              showErrors={showErrors}
              disabled={formDisabled}
            />
          </StyledBoxDesktop>

          <StyledBoxDesktop ml="2x_small" flex={1}>
            <StyledBoxMobile mt="big">
              <FormInput
                id={formFields.PHONE.id}
                label={t('pricefreeze.form.passenger.phone.number')}
                value={data?.[formFields.PHONE.id] || ''}
                type="tel"
                onBlur={onBlur(formFields.PHONE.id)}
                validate={formFields.PHONE.validation}
                showErrors={showErrors}
                disabled={formDisabled}
              />
            </StyledBoxMobile>
          </StyledBoxDesktop>
        </FormRow>
      </Box>
    </>
  );
};
